import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import { Provider } from 'react-redux';
import { App } from './App';
import { CdnUrlProvider } from './components/Cdn/CdnUrlProvider';
import enMessages from './intl/en';
import formats from './intl/formats';
import * as serviceWorker from './serviceWorker';
import createStore from './store/store';
import configureMuiTheme from './styles/configureMuiTheme';
import { resolveUrls } from './utils/resolver';

// tslint:disable-next-line:no-import-side-effect
import './index.css';

if (
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_WHY_DID_YOU_UPDATE
) {
  // tslint:disable-next-line:no-var-requires
  const { whyDidYouUpdate } = require('why-did-you-update');
  whyDidYouUpdate(React, {
    exclude: [
      process.env.REACT_APP_WHY_DID_YOU_UPDATE_EXCLUDE &&
        RegExp(process.env.REACT_APP_WHY_DID_YOU_UPDATE_EXCLUDE),
    ],
  });
}

const theme = configureMuiTheme();

addLocaleData([...en]);

resolveUrls().then((urls) => {
  const store = createStore(urls.webApiUrl, urls.metricsApiUrl);

  ReactDOM.render(
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <IntlProvider
          locale="en"
          defaultLocale="en"
          messages={enMessages}
          formats={formats}
        >
          <CdnUrlProvider.Provider value={urls}>
            <App />
          </CdnUrlProvider.Provider>
        </IntlProvider>
      </MuiThemeProvider>
    </Provider>,
    document.getElementById('root'),
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
